module.exports = __webpack_public_path__ + "media/images/lb/659-691fe7f3506aae17a8a84e814e61e91a.svg";